<template>
        <card>
           <template slot="header">
              <h3 class="card-title">Coaching Records</h3>
           </template>
           <div class="row">
                <nav>
                <ol class="breadcrumb arr-right bg-breadcrum">
                    <li class="breadcrumb-item">
                        <router-link to="/hr/dashboard"><i class="fa fa-home"></i>&nbsp;Dashboard</router-link>
                    </li>
                    <li class="breadcrumb-item">
                        <router-link to="/hr/employeelist">Active Employees</router-link>
                    </li>
                    <li class="breadcrumb-item">
                        <router-link to="/hr/resigned">Inactive Employees</router-link>
                    </li>
                    <li class="breadcrumb-item">
                        <router-link to="/hr/dependents">Dependents</router-link>
                    </li>
                    <li class="breadcrumb-item">
                        <router-link to="/hr/workshifts">Workshifts</router-link>
                    </li>
                    <!-- NEW ADDITIONAL -->
                    <li class="breadcrumb-item">
                        <router-link to="/hr/scheduleadjustment">Schedule Adjustment</router-link>
                    </li>
                    <li class="breadcrumb-item">
                        <router-link to="/hr/undertimerequest">Undertime Request</router-link>
                    </li>
                    <li class="breadcrumb-item">
                        <router-link to="/hr/nterequest">NTE Tracker</router-link>
                    </li>
                        <li class="breadcrumb-item active">Employee Coached</li>
                    </ol>
                </nav>
              </div>
           <hr style="margin-top:-10px"/>
           <div class="col-md-12">
              <div class="row">
                 <div class="col-md-7">
                    <p><i class="fa fa-search"></i> Search Employee</p>
                    <input type="test" v-model="search" class="form-control" placeholder="Search..."> 
                 </div>
                 <div class="col-md-2">
                    <p><i class="fa fa-filter"></i> Filter By Year</p>
                     <select v-model="filter_by_year" @change="getYear" class="form-control" required>
                        <option v-for="year in years(2019)">{{ year }}</option>
                     </select>
                  </div>
                 <div class="col-md-1">
                    <div class="form-group">
                       <p><i class="fa fa-sort-numeric-asc"></i>&nbsp;Display</p>
                       <select v-model="page_limit" class="form-control" required>
                          <option value="">Default</option>
                          <option value="2">2</option>
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                          <option value="500">500</option>
                       </select>
                    </div>
                 </div>
                 <!-- <div class="col-md-2">
                    <div class="form-group">
                        <p><i class="fa fa-filter"></i>&nbsp;Filter by Status:</p>
                        <select v-model="filter_by_status" class="form-control" required>
                            <option value="">Default</option>
                            <option value="pending">pending</option>
                            <option value="approved">approved</option>
                            <option value="rejected">rejected</option>
                        </select>
                    </div>
                    </div> -->
                 <div class="col-md-2">
                    <div class="form-group">
                       <p><i class="fa fa-sort-amount-asc"></i>&nbsp;Order by </p>
                       <select v-model="order_by" class="form-control" required>
                          <option value="">Default</option>
                          <option value="1">ASC</option>
                          <option value="-1">DESC</option>
                       </select>
                    </div>
                 </div>
              </div>
           </div>
           <hr>
           <div class="table-responsive ">
             <!-- PAGINATION NATIVE WAY -->
             <div class="row">
                    <div class="col-md-6">
                        <p style="color:#9a9a9a">Page {{curentPage}} out of {{total_item}} records</p>
                    </div>
                    <div class="col-md-6">
                        <b-pagination
                            v-model="curentPage"
                            :total-rows="items.length"
                            :per-page="perPage"
                            aria-controls="my-table"
                            align="right"
                            first-text="First"
                            prev-text="Prev"
                            next-text="Next"
                            last-text="Last"
                        ></b-pagination>
                    </div>
                    </div>
                <!-- END PAGINATION -->   
              <table class="table table-striped table-hover " v-loading="loading">
                 <thead>
                    <tr>
                       <th width="150">Date Coached</th>
                       <th width="250">Employee Name</th>
                       <th width="380">Performance</th>
                       <th width="250">Coached By</th>
                       <th width="200">Action</th>
                    </tr>
                 </thead>
                 <tbody>
                    <tr v-for="item in computedRequest">
                       <td><i class="fa fa-calendar"></i>&nbsp;{{item.date_coaching}}</td>
                       <td>{{item.first_name | capitalize}}, {{item.last_name | capitalize}}</td>
                       <td>
                         <template v-if="item.performance.length < 50">{{item.performance | capitalize}}</template>
                         <template v-if="item.performance.length >= 50">{{ item.performance.substring(0,50)+"..." | capitalize}}</template>
                       </td>
                       <td>{{item.superior_name}}</td>
                       <td>
                          <span v-if="item.employee_status == 'acknowledged'">
                             <router-link :to="{name: 'coaching-records-details', params: { id: item.coach_id }}" class="leave-link"><u><i class="fa fa-eye"></i>View Details</u></router-link>
                          </span>
                          <span v-if="item.employee_status == 'unacknowledged'">
                            <router-link :to="{name: 'coaching-records-details', params: { id: item.coach_id }}" class="leave-link"><u><i class="fa fa-eye"></i>View Details</u></router-link>
                          </span>
                       </td>
                    </tr>
                 </tbody>
              </table><br/>
              <!-- PAGINATION NATIVE WAY -->
              <div class="row">
                    <div class="col-md-6">
                        <p style="color:#9a9a9a">Page {{curentPage}} out of {{total_item}} records</p>
                    </div>
                    <div class="col-md-6">
                        <b-pagination
                            v-model="curentPage"
                            :total-rows="items.length"
                            :per-page="perPage"
                            aria-controls="my-table"
                            align="right"
                            first-text="First"
                            prev-text="Prev"
                            next-text="Next"
                            last-text="Last"
                        ></b-pagination>
                    </div>
                    </div>
                <!-- END PAGINATION -->
                       <!-- If Lost Connection on Server -->   
                        <template v-if="display_indicator === 1">
                            <center>
                            <br/><br/>
                            <img  src="/static/img/warning.png"  width="225" height="190">
                            <h1>You've lost your network connection</h1>
                            <h3>Check your wireless settings, or your network cable, and reload the page.</h3>
                            <br/><br/>
                            </center>
                        </template>
           </div>
        </card>
     </template>
    <script>
    /* eslint-disable */
    import Card from 'src/components/UIComponents/Cards/Card.vue'
    export default {
        components: {
            Card,     
        },
        data(){
           return{
              items:[],
              //FILTER
              page_limit:'',
              order_by:'',
              search:'',
              loading:true,
              filter_by_year:'',
            //SORTING
            page_limit:'',
            start_page:1,
            //PAGINATION
            perPage: 100,
            curentPage:1,
              //Indicator
            display_indicator: '',
             
    
           }
        },
        created:function(){
          this.employeeCoached()
        }, 
        methods:{
             getYear(){
                if(this.filter_by_year == ''){
                    this.employeeCoached()
                }else{
                     axios.get('api/employee/coached/all/' + this.filter_by_year)
                .then(response => {
                    this.items = response.data;
                })
                .catch(error => {
                    console.log(error.response)
                });
                } 
            },
            employeeCoached(){
                axios.get('api/employee/coached/all')
                .then(resp => {  this.items = resp.data;  this.loading = false; console.log(resp.data);  this.display_indicator = 2;})  
                .catch(error => {  console.log(error.resp);  this.display_indicator = 1;  });
            },
     
        },
        computed:{
      offset() {  return (this.start_page - 1) * this.page_limit; },
      limit() { return this.offset + this.page_limit; },   
      total_item(){ return this.items.length }, 

      computedRequest(){
          let filtered = this.items
         // USE IN PAGINATION 
          let start = (this.curentPage-1) * this.perPage
          let end = this.curentPage * this.perPage
          filtered = filtered.slice(start, end)

        // SORTING NUMBER OF DISPLAY
        if(this.page_limit){
            filtered =  filtered.slice(this.offset, this.limit);
            return filtered
            }

        if(this.search) {
            filtered = filtered.filter(
            item => item.first_name.toLowerCase().indexOf(this.search) > -1
            );
            return filtered
        }
        // ORDER BY ASC AND DESC COMBOBOX
        if(this.order_by){
                filtered = filtered.slice(0).sort((a, b) => a.first_name < b.first_name ? this.order_by : -this.order_by )
                return filtered
            } 
                
          return filtered   
       }
},
    }
    </script>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-employee-management/todo-coaching-record.vue